import { Task } from 'packages/lib/api/annotations/contract/task';

export const allEqualAnnotationState = (
  tasks: Pick<Task, 'annotationState'>[]
) => tasks.every((task) => task.annotationState === tasks[0].annotationState);

export const allHaveAssignee = (
  tasks: Pick<Task, 'assignee'>[],
  assignee: string | null = null
) => tasks.every((task) => task.assignee === assignee);

export const getTaskObjectToken = (task: Task): string => {
  // Per Data Services, the task.tag will ALWAYS be prefixed with "objectToken." for Scene Enrichment queues
  return task.tag?.substring('objectToken.'.length) ?? '';
};

export const taskHasObjectToken = (task: Task): boolean => {
  return !!task.tag && task.tag.startsWith('objectToken.');
};
